export class Route {

    constructor(options={}) {
        this.location = options.location ?? '/';
        this.processedParams = options.processedParams ?? {};

        this.checkQueryParams();
    }

    checkQueryParams() {
        if (location.pathname == this.location) {
            const params = (new URL(document.location)).searchParams;

            Object.keys(this.processedParams).forEach(key => {
                const paramList = key.split('|');

                for (const parameter of paramList) {
                    const param = params.get(parameter);
                    const callback = this.processedParams[key];
                    if(!!param) callback(param, parameter);
                }

            });
        }
    }

    static init(options={}) {
        return new Route(options);
    }
}
